import moment from "moment";

import { useCookies } from "vue3-cookies";
class CommonHelper {
    setAuth(data) {
        debugger;
        let { token } = data;
        let time = moment().add(30, "days").toDate();
        //localStorage.token = token;
        localStorage.setItem('user', JSON.stringify(data))
        const { cookies } = useCookies();
        // Set a cookie with an expiration time of one hour
        const expirationDate = new Date(Date.now() + 3600000); // One hour from now
        const formattedDate = expirationDate.toUTCString();
        cookies.set("user", data, formattedDate);


        // VueCookies.set("session_details", user, time);
        // store.commit("SET_AUTH");
        // store.commit("SET_RIGHTS", user_rights);

    }
}
export default new CommonHelper();